// Pravý cluster horní lišty: uživatelské menu · Nástroje · helpdesk (vykřičník).
// Nástroje se zobrazí podle Phoenix oprávnění (hned po přihlášení); helpdesk až podle Magic user-info.

import { useTranslation } from 'react-i18next';

import { useMagicDesktopStore } from '@/shared/legacyMagicBridge';
import { Icon } from '@/shared/ui/icon';

import { DesktopToolsButton } from './DesktopToolsButton';
import { UserAccountMenu } from './UserAccountMenu';

function HelpButton({ url }: { url: string }) {
  const { t } = useTranslation('common');
  return (
    <button
      type="button"
      className="rounded-phx-sm text-phx-text-2 hover:bg-phx-surface-2 flex h-[24px] w-[28px] cursor-pointer items-center justify-center border-0 bg-transparent"
      title={t('help.open')}
      aria-label={t('help.open')}
      onClick={() => window.open(url, '_blank', 'noopener')}
    >
      <Icon name="exclamation" size={16} />
    </button>
  );
}

export function DesktopHeaderControls() {
  const userInfo = useMagicDesktopStore((s) => s.userInfo);

  return (
    <div className="flex items-center gap-0.5">
      <UserAccountMenu />
      {/* DesktopToolsButton se zobrazuje vždy — obsahuje vždy dostupného „Průvodce okny" (bez oprávnění). */}
      <DesktopToolsButton />
      {userInfo?.helpdeskUrl && <HelpButton url={userInfo.helpdeskUrl} />}
    </div>
  );
}
